/**
 * JSON utilities with safe error handling
 */

/**
 * Safely parse JSON with a fallback value
 * @param text The JSON string to parse
 * @param fallback The fallback value if parsing fails
 */
export function safeJsonParse<T>(text: string, fallback: T): T {
  if (!text) return fallback;
  try {
    return JSON.parse(text) as T;
  } catch {
    return fallback;
  }
}

/**
 * Parse JSON and return a typed result or null
 * @param text The JSON string to parse
 */
export function parseJsonOrNull<T>(text: string): T | null {
  if (!text) return null;
  try {
    return JSON.parse(text) as T;
  } catch {
    return null;
  }
}

/**
 * Try to extract an error message from a JSON response
 */
export function extractErrorMessage(text: string, fallback: string): string {
  const parsed = parseJsonOrNull<Record<string, unknown>>(text);
  if (parsed) {
    if (typeof parsed.error === "string") return parsed.error;
    if (typeof parsed.message === "string") return parsed.message;
    if (typeof parsed.detail === "string") return parsed.detail;
  }
  return fallback;
}
